'use strict';

/**
 * @author Maxim Seredkin
 */

export default ['$scope', 'LandCategoryService',
                function($scope, LandCategoryService) {
                    $scope.categories = {};
                    LandCategoryService.api.get({
                                                    filters: [`'status' EQ 'ENABLED'`],
                                                    sorts: ['npp:ASC', 'name:ASC'],
                                                }, (data) => {
                        $scope.categories = data._embedded;
                    });
                }];
